__turbopack_context__.v({
  "avatar": "CandidateCardMultiProfessional-module__QxP5cG__avatar",
  "avatarBlurred": "CandidateCardMultiProfessional-module__QxP5cG__avatarBlurred",
  "avatarFallback": "CandidateCardMultiProfessional-module__QxP5cG__avatarFallback",
  "avatarGrid": "CandidateCardMultiProfessional-module__QxP5cG__avatarGrid",
  "avatarImage": "CandidateCardMultiProfessional-module__QxP5cG__avatarImage",
  "avatarMore": "CandidateCardMultiProfessional-module__QxP5cG__avatarMore",
  "avatarPanel": "CandidateCardMultiProfessional-module__QxP5cG__avatarPanel",
  "bottom": "CandidateCardMultiProfessional-module__QxP5cG__bottom",
  "card": "CandidateCardMultiProfessional-module__QxP5cG__card",
  "cta": "CandidateCardMultiProfessional-module__QxP5cG__cta",
  "ctaIcon": "CandidateCardMultiProfessional-module__QxP5cG__ctaIcon",
  "headings": "CandidateCardMultiProfessional-module__QxP5cG__headings",
  "headingsText": "CandidateCardMultiProfessional-module__QxP5cG__headingsText",
  "meta": "CandidateCardMultiProfessional-module__QxP5cG__meta",
  "metaSeparator": "CandidateCardMultiProfessional-module__QxP5cG__metaSeparator",
  "moreSkills": "CandidateCardMultiProfessional-module__QxP5cG__moreSkills",
  "recruiterLogo": "CandidateCardMultiProfessional-module__QxP5cG__recruiterLogo",
  "recruiterLogoPlaceholder": "CandidateCardMultiProfessional-module__QxP5cG__recruiterLogoPlaceholder",
  "root": "CandidateCardMultiProfessional-module__QxP5cG__root",
  "skill": "CandidateCardMultiProfessional-module__QxP5cG__skill",
  "skillEmoji": "CandidateCardMultiProfessional-module__QxP5cG__skillEmoji",
  "skillLogo": "CandidateCardMultiProfessional-module__QxP5cG__skillLogo",
  "skillsList": "CandidateCardMultiProfessional-module__QxP5cG__skillsList",
  "skillsPanel": "CandidateCardMultiProfessional-module__QxP5cG__skillsPanel",
  "title": "CandidateCardMultiProfessional-module__QxP5cG__title",
  "top": "CandidateCardMultiProfessional-module__QxP5cG__top",
});
